import React from "react";

const PreLoader = () => {
  return (
    <div class="preloader">
      <div class="status">
        <div class="status-mes"></div>
      </div>
    </div>
  );
};

export default PreLoader;
